import React from 'react';
import MetaTags from 'react-meta-tags';

const Metadata = ({meta : {title, description}} = props) => {
    // console.log("TITLE:",title, description)
    return (
        <MetaTags>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            <meta property="og:title" content={`${title} | Hacker Noon`} />
            <meta property="og:image" content="public/hn-terminal.jpg" />
            <meta key="monetization" name="monetization" content="$ilp.uphold.com/z7rXWqEwUBrf" />
        </MetaTags>
    )
}

export default Metadata;